import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Register from "./Register";
import SignInModalContent from "./SignInModalContent";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../State/Auth/Action";

const AuthModal = ({ handleClose, open }) => {
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const authUser = useSelector((state) => state.auth.user);
  const [view, setView] = useState("login"); // Default to login view

  useEffect(() => {
    if (jwt && authUser?.role === "CUSTOMER") {
      dispatch(getUser(jwt));
    }
  }, [jwt, dispatch, authUser?.role]);

  useEffect(() => {
    if (authUser?.role === "CUSTOMER") {
      handleClose();
    }
  }, [authUser, handleClose]);

  // Add listener for custom close event
  useEffect(() => {
    const handleCustomClose = () => {
      handleClose();
    };

    window.addEventListener('closeAuthModal', handleCustomClose);

    return () => {
      window.removeEventListener('closeAuthModal', handleCustomClose);
    };
  }, [handleClose]);

  const renderContent = () => {
    if (view === "register") {
      return <Register handleClose={handleClose} switchToLogin={() => setView("login")} />;
    }
    return <SignInModalContent handleClose={handleClose} switchToRegister={() => setView("register")} />;
  };

  const handleModalClose = (event, reason) => {
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby="login-modal-title"
      aria-describedby="login-modal-description"
      BackdropProps={{}}
    >
      {renderContent()}
    </Modal>
  );
};

export default AuthModal;
